// ─── Pagination ──────────────────────────────────────────────────────
export const PAGE_SIZE = 200;
export const VOB_READY_PAGE_SIZE = 30;
export const SKELETON_ROW_COUNT = 10;

// ─── Search ──────────────────────────────────────────────────────────
export const SEARCH_DEBOUNCE_MS = 300;

// ─── Truncation ──────────────────────────────────────────────────────
export const TRUNCATE_CASE_ID = 20;
export const TRUNCATE_CALL_ID = 16;
export const TRUNCATE_DEFAULT = 20;

// ─── Date formats ────────────────────────────────────────────────────
export const DATE_FORMAT_SHORT = "MMM dd, h:mm a";
export const DATE_FORMAT_FULL = "MMM dd yyyy, h:mm a";

// ─── Export ──────────────────────────────────────────────────────────
export const COLUMN_MAX_EXPORT_WIDTH = 50;
